import React, { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components/";
import { _PasswordField } from "../../form/";
import { _ButtonAPI } from "../../components/";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    closeButton: {
        position: "absolute",
        right: spacing(2),
        top: spacing(2),
        color: palette.grey[500]
    },
    content: {
        paddingBottom: spacing(7)
    }
}));

interface IPasswordChangeProps {
    Open: boolean;
    UserId: number;
    OnClose: () => void;
    SetDialog: (v: Glob.CDialog) => void;
}

export const _PasswordChange: React.FC<IPasswordChangeProps> = ({ Open, UserId, SetDialog, OnClose }) => {
    const classes = useStyles();
    const [newPassword, setNewPassword] = useState("");
    const [confirmedPassword, setConfirmedPassword] = useState("");

    const onClickChangePassword = (data: Dati.CRisAPI) => {
        OnClose();

        if (data.Errore) {
            SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(data.ErrTesto), Type: "error" });
        } else {
            SetDialog({ Open: true, Title: "Password change", Content: Trad.Trad("Password has been changed"), Type: "success" });
        }
    };

    const OnError = (error: Error) => {
        OnClose();
        SetDialog({ Open: true, Title: "ERRORE", Content: Trad.Trad(error.message), Type: "error" });
    };

    const isFormValid = !!(newPassword && confirmedPassword && newPassword == confirmedPassword);

    return (
        <Dialog fullWidth maxWidth="xs" open={Open} onClose={OnClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <Typography variant="subtitle2" component="p">
                    {Trad.Trad("Password change")}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={OnClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers className={classes.content}>
                <form noValidate>
                    <Grid container justify="center" spacing={4}>
                        <Grid item xs={12} sm={8}>
                            <_PasswordField Value={newPassword} Label="New password" OnChange={e => setNewPassword(e.currentTarget.value)} />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <_PasswordField Value={confirmedPassword} Label="Confirm password" OnChange={e => setConfirmedPassword(e.currentTarget.value)} HideBar />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={OnClose}>{Trad.Trad("Chiudi")}</Button>
                <_ButtonAPI
                    Default
                    URL={`/api/Utenti/inar2/InAR2_ChangePassword/${UserId}`}
                    Metodo="PUT"
                    Testo={Trad.Trad("Cambia")}
                    ParamCorpo={{ Password: newPassword }}
                    OnClick={onClickChangePassword}
                    OnErrore={OnError}
                    Attivo={isFormValid}
                />
            </DialogActions>
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/PasswordChange.tsx